import React, { Fragment } from 'react';

import PickupOrder from '../../../models/PickupOrder';

import {Grid} from '@material-ui/core';

import style from './ordersStyle.module.css';

interface CommonOrderTruckerInformationProps {
  pickupOrder: PickupOrder;
  type: string;
};

const commonOrderTruckerInformation = (props: CommonOrderTruckerInformationProps) => {

const showFields: boolean = (props.pickupOrder.trucker_info || props.pickupOrder.driver_name || props.pickupOrder.driver_id ||
  props.pickupOrder.driver_vehichle_registration || props.pickupOrder.driver_contact ) ? true : false;
  
  return(
    <div>
      { showFields && 

      <Fragment>

        <Grid container className={ style.infoGridContainer }>
          <Grid item md={2} xs={6} className={ style.infoGridItem }>
            <div className={ style.infoWrapper}>
              <div className={ style.pot }> Truck Plate Number:</div>
              <div className={ style.pod }>{ props.pickupOrder.driver_vehichle_registration || 'Not Assigned' }</div>
            </div>
          </Grid>

          <Grid item md={2} xs={6} className={ style.infoGridItem }>
            <div className={ style.infoWrapper}>
              <div className={ style.pot }> Drivers Name:</div>
              <div className={ style.pod }>{ props.pickupOrder.driver_name || 'Not Assigned' }</div>
            </div>
          </Grid>

          <Grid item md={2} xs={6} className={ style.infoGridItem }>
            <div className={ style.infoWrapper}>
              <div className={ style.pot }> Driver's ID type:</div>
              <div className={ style.pod }>{ props.pickupOrder.driver_id_type || 'Not Assigned' }</div>
            </div>
          </Grid>

          <Grid item md={2} xs={6} className={ style.infoGridItem }>
            <div className={ style.infoWrapper}>
              <div className={ style.pot }> Driver's ID:</div>
              <div className={ style.pod }>{ props.pickupOrder.driver_id.replace(/.(?=.{4,}$)/g, '#') || 'Not Assigned' }</div>
            </div>
          </Grid>

          <Grid item md={2} xs={6} className={ style.infoGridItem }>
            <div className={ style.infoWrapper}>
              <div className={ style.pot }> Driver Contact:</div>
              <div className={ style.pod }>{ props.pickupOrder.driver_contact || 'Not Assigned' }</div>
            </div>
          </Grid>
         
        </Grid>

      </Fragment>
  
      }
    </div>
  )
}

export default commonOrderTruckerInformation;